import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-contents-aside',
	templateUrl:'./WaPageContentsAsideProPage.html',
	styles: [],
	styleUrls:['./WaPageContentsAsideProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageContentsAsideProPage
{
	mdContent_384 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageContentsAside;
\`\`\``;
	mdContent_385 = `\`\`\`java
new WaPageContentsAside<>()
\`\`\``;
}
